// Mock data for the website

export const mockTestimonials = [
  {
    name: 'Verified Client',
    title: 'Land Seller (Washington State)',
    text: 'Very informative and consistent updates. Vahid connected me with the right people to complete the sale of my property, and he was the foundation that directed the best outcome. My realtor here in Washington State researched and found Vahid Rajabian to be the best — he was right!',
    source: 'RateMyAgent'
  },
  {
    name: 'Verified Client',
    title: 'Land Seller',
    text: 'When I first decided that I wanted to sell my land, other realtors were encouraging me to list for less than half the price of what my lot was worth. After I met Vahid he told me he would be able to sell my land at the real market value. He was patient, thorough and helpful, and even when I was willing to compromise in pricing he encouraged me that my land will sell. He gave me the confidence I needed. I highly recommend Vahid because he is honest and reliable.',
    source: 'RateMyAgent'
  },
  {
    name: 'Verified Client',
    title: 'Lot Buyer',
    text: 'Vahid is phenomenal. He is accessible and extremely patient. My experience overall is top rated. My tip to anyone purchasing land: Do your research first and make your payments on time! It\'s easy as pie. Vahid is an absolute pleasure to work with.',
    source: 'RateMyAgent'
  },
  {
    name: 'Verified Client',
    title: 'Lot Buyer',
    text: 'Exceptional Customer Service and precise and detailed information offered. Vahid offered us plot plans precisely laid out, highlighted and manually numbered each to maximize our time. We were able to complete more research in one day than previously done with another agency. We purchased our lot the exact same day.',
    source: 'RateMyAgent'
  },
  {
    name: 'Verified Client',
    title: 'Veteran Homebuyer',
    text: 'Very Professional and very Honest!!! Thank you for an amazing experience. My family and friends now have the space to gather and participate in outdoor activities for generations to come. Thank you again for making a positive difference in our world.',
    source: 'RateMyAgent'
  },
  {
    name: 'Verified Client',
    title: 'Buyer',
    text: 'Mr. Rajabian was extremely professional and always available to answer any questions I had. His many years of experience in Palm Bay were evident — he knows the market exceptionally well and has strong connections throughout the area.',
    source: 'RateMyAgent'
  },
  {
    name: 'Verified Client',
    title: 'Buyer',
    text: 'Very transparent and professional.',
    source: 'RateMyAgent'
  }
];

export const mockFeaturedProperties = [
  {
    name: 'Unit 49 Residential Lot',
    price: '$41,000',
    features: [
      '10,000 sq ft',
      'Ready to build',
      'Owner financing available'
    ],
    houseImage: 'https://customer-assets.emergentagent.com/job_palmbayhomes/artifacts/px90l2uq_SL_Elev_StAugustine_ECFL.jpg',
    lotImage: 'https://customer-assets.emergentagent.com/job_palmbayhomes/artifacts/wq6egnpq_Toy%20St..png'
  },
  {
    name: 'Unit 15 Residential Lot',
    price: '$45,000',
    features: [
      '10,000 sq ft',
      'Ready to build',
      'Owner financing available'
    ],
    houseImage: 'https://customer-assets.emergentagent.com/job_palmbayhomes/artifacts/j660h8eq_0222c589-3205-48d7-82ad-53e1cf69afc0.png',
    lotImage: 'https://customer-assets.emergentagent.com/job_palmbayhomes/artifacts/50ryruds_Sagbloom%202.png'
  },
  {
    name: 'Unit 16 Residential Lot',
    price: '$65,000',
    features: [
      '10,000 sq ft',
      'City water available',
      'Owner financing available'
    ],
    houseImage: 'https://customer-assets.emergentagent.com/job_palmbayhomes/artifacts/px90l2uq_SL_Elev_StAugustine_ECFL.jpg',
    lotImage: 'https://customer-assets.emergentagent.com/job_palmbayhomes/artifacts/thrmlyrz_Wilkinson-2%20BCPAO%20-%20MapView.png'
  }
];